import { styled } from "@mui/material/styles";
import { Button, IconButton } from "@mui/material";

export const StyledContainer = styled("div")({});

export const Title = styled("span")({
  fontSize: "16px"
});

export const GroupLabel = styled("span")({
  display: "flex",
  alignItems: "center",
  columnGap: "8px",
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 500,
  marginBottom: "16px",
  color: "var(--Color-Text-Primary-On-Light, #1F1F1F)"
});

export const InfoIconButton = styled(IconButton)({
  paddingLeft: "0px"
});

export const FlexContainer = styled("div")({
  marginTop: "0",
  marginBottom: "0"
});

export const Divider = styled("div")({
  marginTop: "0px",
  borderBottom: "solid 1px rgba(230, 230, 230, 0.5)"
});

export const ControlsWrapper = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
  margin: "20px 0 0"
});

export const DisabledInput = styled("div")({
  backgroundColor: "rgba(242, 242, 242, 0.5)"
});

export const InfoTitlesStyle = styled("div")({
  color: "#86868b"
});

export const NonCashTitleStyle = styled("div")({
  position: "relative",
  top: "-10px",
  marginBottom: "10px"
});

export const ButtonWrapper = styled("div")({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  margin: "40px 0"
});

export const StyledFormControl = styled("div")({
  "& > div:last-child": {
    marginTop: "10px"
  }
});

export const DnfbpStyle = styled("h6")({
  fontWeight: "normal",
  marginBottom: "0px",
  marginTop: "0px"
});

export const DnfbpTitleWrapper = styled("div")({
  margin: "15px 0",
  display: "flex",
  alignItems: "center"
});

export const DnfbpHelp = styled("span")({
  color: "#909093",
  marginLeft: "5px",
  fontSize: "12px",
  textDecoration: "underline",
  textTransform: "none"
});

export const IconStyle = styled("div")({
  width: "2px",
  height: "2px"
});

export const MarginT5 = styled(Button)({
  marginTop: "5px"
});

export const PaddingH12 = styled("div")({
  paddingLeft: "12px",
  paddingRight: "12px"
});

export const DispFlxJustEnd = styled("div")({
  display: "flex",
  justifyContent: "flex-end"
});
